import { Injectable } from "@angular/core";
import { UserContext } from "../shared/models/user-context";

@Injectable({
  providedIn: "root"
})
export class SessionService{
  private _userContextKey = "user.context";
  private _userContextRefreshFlag = "user.refresh";

  getUserContext(){
    let ctx = window.sessionStorage.getItem(this._userContextKey);
    return ctx ? JSON.parse(ctx) : null;
  }

  setUserContext(userContext: UserContext){
    window.sessionStorage.setItem(this._userContextKey, JSON.stringify(userContext));
    window.sessionStorage.setItem(this._userContextRefreshFlag, "0");
  }

  clearUserContext(){
    window.sessionStorage.removeItem(this._userContextKey);
    window.sessionStorage.removeItem(this._userContextRefreshFlag);
  }

  refreshUserContext(){
    window.sessionStorage.setItem(this._userContextRefreshFlag, "1");
  }

  shouldRefreshUserContext(){
    let flag = window.sessionStorage.getItem(this._userContextRefreshFlag);
    return flag ? flag === "1" : false;
  }
}